/**
 * Created by rathompson on 5/2/22
 * File: NewTagModal
 * Project: MSP ©Palo Alto Networks
 * © Palo Alto Networks
 */

import { useEffect } from 'react'
import { Modal, ModalBody, ModalHeader, Button, ModalFooter } from '@panwds/react-ui'
import {
  BUTTON_CANCEL,
  BUTTON_SAVE, BUTTON_SELECT_APPLICATIONS,
  LABEL_ASSOCIATE_APP,
  LABEL_CREATE_NEW_TAG,
  TITLE_ADD_NEW_TAG,
} from '../../constants/LabelConstants'
import { Form, SubmitButton, Input, Select } from '@panwds/react-form'
import { useFormContext } from 'react-hook-form'

const MOCK_APPS = [
  {
    value: 'Cloud Management',
  },
  {
    value: 'Cloud Identity Engine',
  },
  {
    value: 'Cortex Data Lake',
  }
]

const Footer = ({ closeModal }) => {

  const { formState } = useFormContext()
  const { isValid } = formState

  return (
    <ModalFooter>
      <Button onClick={closeModal}>{BUTTON_CANCEL}</Button>
      <SubmitButton disabled={!isValid}>{BUTTON_SAVE}</SubmitButton>
    </ModalFooter>
  )
}

const NewTagModal = ({ closeModal, isOpen }) => {

  useEffect(() => {
    const modalMask = document.getElementsByClassName('tw-bg-gray-900 tw-fixed tw-inset-0 tw-z-10 tw-transition-opacity tw-duration-200 tw-opacity-75')
    if (modalMask && modalMask.length) {
      modalMask[0].style.zIndex = 1052
    }
  }, [isOpen])

  return (
    <Modal style={{ zIndex: 1052, top: '30%', width: '400px', height: '304px' }} isOpen={isOpen} onClose={closeModal}>
      <Form mode='onBlur' formProps={{ style: { height: '100%', width: '100%', display: 'flex', flexDirection: 'column' } }}>
        <ModalHeader title={TITLE_ADD_NEW_TAG}/>
        <ModalBody>
          <div className='tw-w-1/2 tw-h-full tw-flex tw-flex-col tw-gap-4'>
            <Input
              name='name'
              label={LABEL_CREATE_NEW_TAG}
              placeholder='Tag-05'
              register={{
                required: true
              }}
            />
            <Select
              addClassName='cmm-modal-select'
              fullWidth
              items={MOCK_APPS}
              name='associated_app'
              label={LABEL_ASSOCIATE_APP}
              enableMultiSelect
              register={{
                required: false
              }}
              button={
                <Button
                  addClassName='tw-justify-between tw-mt-2'
                  fullWidth
                  isMenu
                  appearance='tertiary'
                >{BUTTON_SELECT_APPLICATIONS}</Button>
              }
            />
          </div>
        </ModalBody>
        <Footer {...{ closeModal }}/>
      </Form>
    </Modal>
  )
}

NewTagModal.propTypes = {}
export default NewTagModal
